import Skeleton from "@mui/material/Skeleton";
import { FC } from "react";

export const SkeletonHeaderButtons: FC = () => {
  return (
    <>
      <Skeleton variant="rounded" width={40} height={40} />

      <Skeleton variant="rounded" width={80} height={40} />
    </>
  );
};
